import { ICBC_DEFAULTS } from '../constants/directDebitIcbcConstants';

export const toDateInputValue = (date = new Date()) => {
  const timezoneOffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - timezoneOffset).toISOString().slice(0, 10);
};

export const formatCurrency = (value) => {
  const numberValue = Number(value || 0);
  return numberValue.toLocaleString('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 2,
  });
};

export const formatDateDisplay = (value) => {
  if (!value) return '-';
  const [year, month, day] = String(value).split('-');
  if (!year || !month || !day) return value;
  return `${day}/${month}/${year}`;
};

export const isPastDateInputValue = (value) => {
  if (!value) return false;
  return String(value) < toDateInputValue(new Date());
};

export const cleanDirectDebitIcbcFilters = (filter) => {
  const month = Number(filter.month);
  const year = Number(filter.year);
  const cleaned = {
    due_date: filter.due_date,
    cuit: String(filter.cuit || '').replace(/\D/g, ''),
    currency: String(filter.currency || '0').trim(),
    prestation: String(filter.prestation || ICBC_DEFAULTS.prestation).trim().toUpperCase(),
  };

  if (month && year) {
    cleaned.month = month;
    cleaned.year = year;
  }

  return cleaned;
};

export const getDirectDebitIcbcErrorMessage = (error, fallback) => {
  const payload = error?.response?.data;

  if (payload?.message) return payload.message;
  if (payload?.error) return payload.error;
  if (typeof payload === 'string') return payload;
  if (error?.message) return error.message;

  return fallback;
};
